import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustedBy } from './components/TrustedBy';
import { HowItWorks } from './components/HowItWorks';
import { WhyChoose } from './components/WhyChoose';
import { SampleTasks } from './components/SampleTasks';
import { CandidateReport } from './components/CandidateReport';
import { Pricing } from './components/Pricing';
import { Security } from './components/Security';
import { ForDevelopers } from './components/ForDevelopers';
import { About } from './components/About';
import { CtaBanner } from './components/CtaBanner';
import { Footer } from './components/Footer';
import { SEO } from './components/SEO';
import { StructuredData } from './components/StructuredData';
export function App() {
  return <>
      <SEO data-id="element-0" />
      <StructuredData data-id="element-1" />
      <noscript data-id="element-2">
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PTPFTZ9Z" height="0" width="0" style={{
        display: 'none',
        visibility: 'hidden'
      }} data-id="element-3"></iframe>
      </noscript>
      <div className="font-sans text-gray-900 bg-white" data-id="element-4">
        <Header data-id="element-5" />
        <main data-id="element-6">
          <Hero data-id="element-7" />
          <TrustedBy data-id="element-8" />
          <HowItWorks data-id="element-9" />
          <WhyChoose data-id="element-10" />
          <SampleTasks data-id="element-11" />
          <CandidateReport data-id="element-12" />
          <Pricing data-id="element-13" />
          <Security data-id="element-14" />
          <ForDevelopers data-id="element-15" />
          <About data-id="element-16" />
          <CtaBanner data-id="element-17" />
        </main>
        <Footer data-id="element-18" />
      </div>
    </>;
}